import HeroSection from "./components/HeroSection";
import ChannelQuickEntry from "./components/ChannelQuickEntry";
import LiveNowStrip from "./components/LiveNowStrip";
import LatestLives from "./components/LatestLives";
import PlatformIntro from "./components/PlatformIntro";

export default function Home() {
  return (
    <div className="w-full">
      <HeroSection />
      <ChannelQuickEntry />
      <LiveNowStrip />
      <LatestLives />
      <PlatformIntro />
    </div>
  );
}